import React from 'react'

import { FIELD_REFERENCES, TABLE_FIELDS } from '../constants'
import { getItemId, getOptionLabel, normalizeFieldValue } from '../utils/tableHelpers'
import { FieldInput, FieldLabel, FieldLabelText, FieldSelect } from './style'

const DatabaseField = ({
    field,
    value,
    onChange,
    selectedTable,
    referenceOptions,
    referencesLoading,
    withLabel = true,
}) => {
    const fieldType = TABLE_FIELDS[selectedTable]?.[field]
    const refTable = FIELD_REFERENCES[field]

    const handleChange = (nextValue) => {
        onChange(field, normalizeFieldValue(nextValue, fieldType))
    }

    const renderControl = () => {
        if (!fieldType) {
            return <span>{value ?? '—'}</span>
        }

        if (refTable) {
            const options = referenceOptions[refTable] || []

            return (
                <FieldSelect
                    value={value ?? ''}
                    disabled={referencesLoading}
                    onChange={(event) => handleChange(event.target.value)}
                >
                    <option value="">
                        {referencesLoading ? 'Загрузка...' : `Выберите ${field}`}
                    </option>
                    {options
                        .filter((item) => getItemId(item) !== '')
                        .map((item, index) => {
                            const itemId = getItemId(item)

                            return (
                                <option key={`${field}-${itemId}-${index}`} value={itemId}>
                                    {getOptionLabel(item)}
                                </option>
                            )
                        })}
                </FieldSelect>
            )
        }

        if (fieldType === 'checkbox') {
            return (
                <FieldInput
                    type="checkbox"
                    checked={Boolean(value)}
                    onChange={(event) => handleChange(event.target.checked)}
                />
            )
        }

        return (
            <FieldInput
                type={fieldType}
                value={value ?? ''}
                onChange={(event) => handleChange(event.target.value)}
            />
        )
    }

    if (!withLabel) {
        return renderControl()
    }

    return (
        <FieldLabel>
            <FieldLabelText>{field}</FieldLabelText>
            {renderControl()}
        </FieldLabel>
    )
}

export default DatabaseField
